import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer" id="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section footer-brand">
            <h3>Archaas</h3>
            <p>
              Streamlining architectural design
              <br />
              for the modern world.
            </p>
          </div>

          <div className="footer-section">
            <h4>Product</h4>
            <ul>
              <li><a href="#knowledge">Knowledge</a></li>
              <li><a href="#integration">Integration</a></li>
              <li><a href="#demo">Features</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <ul>
              <li>
                <a href="mailto:hello@archaas.com">hello@archaas.com</a>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/archaas/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-legal">
            <p>© Archaas 2025</p>
          </div>
          <div className="footer-links">
            <a href="https://amplified-moon-ecd.notion.site/ARCHAAS-PRIVACY-POLICY-2498a0ce763c80cb8925f8a69df94e9f?pvs=143" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            <a href="https://amplified-moon-ecd.notion.site/ARCHAAS-TERMS-AND-CONDITIONS-2498a0ce763c80e8acabc470eb4ed801?pvs=143" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 